/**
 * Created by mykurisu on 2017/8/2.
 */
import React from 'react'
import axios from 'axios'
import {connect} from 'react-redux'
import {
    Page,
    Preload,
    WKError,
} from '../components'
import {
    ListenerManageSearch,
    ListenerManageTab,
    ListenerManageBottom,
} from '../components/listenerManage'
import '../styles/listenermanage/ListenerManage.css'
import errorImg from '../images/no-source.png'

class ListenerManage extends React.Component {

    componentDidMount() {
        let urlData = this.props.routeParams;
        this.props.dispatch({
            type: 'LISTENER_MANAGE_ID',
            payload: urlData
        });

        document.title = '学员管理';

        axios.get(`/api/${urlData.type}/${urlData.id}/listener_list`,{
            params: {
                granted: 'passed'
            }
        })
            .then((res) => {
                if (res.data.code === 0){
                    for (let i = 0;i<res.data.data.listeners.length;i++){
                        res.data.data.listeners[i].checked = false;
                        res.data.data.listeners[i].type = 'passed'
                    }
                    this.props.dispatch({
                        type: 'LISTENER_MANAGE_PASSED_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'LISTENER_MANAGE_PASSED_APPEND',
                        payload: res.data.data.listeners
                    });
                }
            }).catch((error) => {
            if (error.response && error.response.status === 404) {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '该页面已被删除。',
                        img: errorImg,
                        href: '/?st=listener_manage_404',
                        btn: '去首页看看'
                    }
                });
            } else if (error.response && error.response.status === 403){
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '你不是管理员。',
                        img: errorImg,
                        href: '/?st=listener_manage_403',
                        btn: '去首页看看'
                    }
                });
            }else {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '糟糕！现场过于火爆，请稍后再试。',
                        img: errorImg,
                        href: '/?st=listener_manage_error',
                        btn: '去首页看看'
                    }
                });
            }
        });

        axios.get(`/api/${urlData.type}/${urlData.id}/listener_list`,{
            params: {
                granted: 'rejected'
            }
        })
            .then((res) => {
                if (res.data.code === 0){
                    for (let i = 0;i<res.data.data.listeners.length;i++){
                        res.data.data.listeners[i].checked = false;
                        res.data.data.listeners[i].type = 'rejected'
                    }
                    this.props.dispatch({
                        type: 'LISTENER_MANAGE_REJECTED_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'LISTENER_MANAGE_REJECTED_APPEND',
                        payload: res.data.data.listeners
                    });
                }
            }).catch((error) => {
            if (error.response && error.response.status === 404) {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '该页面已被删除。',
                        img: errorImg,
                        href: '/?st=listener_manage_404',
                        btn: '去首页看看'
                    }
                });
            } else if (error.response && error.response.status === 403){
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '你不是管理员。',
                        img: errorImg,
                        href: '/?st=listener_manage_403',
                        btn: '去首页看看'
                    }
                });
            }else {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '糟糕！现场过于火爆，请稍后再试。',
                        img: errorImg,
                        href: '/?st=listener_manage_error',
                        btn: '去首页看看'
                    }
                });
            }
        });
    }


    render() {

        const {listenermanage, error} = this.props;

        if (error.showError) {
            return (
                <div className="lecture-page">
                    <WKError />
                </div>
            )
        }

        if (!listenermanage.listener_list_passed_init || !listenermanage.listener_list_rejected_init){
            return (
                <Preload />
            )
        }

        return (
            <Page>
                <div className="listener-manage">

                    <ListenerManageSearch />

                    <ListenerManageTab />

                    <ListenerManageBottom />

                </div>
            </Page>
        )
    }
}

export default connect(state => ({
    listenermanage: state.listenermanage,
    error: state.error,
}))(ListenerManage)


// WEBPACK FOOTER //
// ./src/pages/ListenerManage.js